import { ReactElement, useCallback } from 'react';
import { AxiosResultDefaultError } from '../../../../api/request';
import { createFetchContext } from '../../../../components/contexts/FetchContextFactory';
import DisplayError from '../../../../components/info/DisplayError';
import Loading from '../../../../components/info/Loading';
import { getRequestsResolvedForm } from '../api';
import { StudentsRemovalRequestsResolvedFiltersResponse } from '../types';

const { FetchProvider, FetchConsumer, useFetch } = createFetchContext<
  undefined,
  StudentsRemovalRequestsResolvedFiltersResponse,
  AxiosResultDefaultError
>();

export const useStudentsRemovalRequestsResolvedFilters = useFetch;

export function StudentsRemovalRequestsResolvedFiltersConsumer({
  children,
}: {
  children: (args: {
    data: StudentsRemovalRequestsResolvedFiltersResponse;
  }) => ReactElement;
}) {
  return (
    <FetchConsumer>
      {({ data, error, loading, refresh }) => {
        if (error) {
          return (
            <DisplayError
              textBody={error.code}
              retryAction={refresh}
              loadingAction={loading}
            />
          );
        }

        if (loading) {
          return <Loading className="mx-auto" />;
        }

        if (!data) {
          return (
            <DisplayError
              textBody="Data no cargada"
              retryAction={refresh}
              loadingAction={loading}
            />
          );
        }

        return children({ data });
      }}
    </FetchConsumer>
  );
}

export function StudentsRemovalRequestsResolvedFiltersLoader({
  children,
}: {
  children: (args: {
    data: StudentsRemovalRequestsResolvedFiltersResponse;
  }) => ReactElement;
}) {
  const request = useCallback(async () => {
    return getRequestsResolvedForm();
  }, []);

  return (
    <FetchProvider request={request} defaultQuery={undefined} fetchImmediately>
      <StudentsRemovalRequestsResolvedFiltersConsumer>
        {({ data }) => children({ data })}
      </StudentsRemovalRequestsResolvedFiltersConsumer>
    </FetchProvider>
  );
}
